import {Breakpoint, useMediaQuery, useTheme} from '@mui/material';

export const useIsMobile = (breakpoint: Breakpoint | undefined = 'md') => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(breakpoint));
};
